const AllowedCoursesCell = ({ allowedCourseIds = null, onClick }) => {
    if (allowedCourseIds?.length < 1) return 'All Courses'
    return <a href="#" className="fw-semibold" onClick={() => onClick(allowedCourseIds)}>{allowedCourseIds.length} course{allowedCourseIds.length > 1 && 's'}</a>
}

export default AllowedCoursesCell